export const ROUTE_ROUTINE_ID = ":routineId";
export const EVENT_DATE = ":eventDate";

export function routeRoutine(schoolId: string, routineId: string): string {
    return `/school/${schoolId}/routine/${routineId}`;
}

export function routeRoutineEdit(schoolId: string, routineId: string): string {
    return `/school/${schoolId}/routine/${routineId}/edit`;
}

export function routeRoutineImage(schoolId: string, routineId: string): string {
    return `/school/${schoolId}/routine/${routineId}/image`;
}

export function routeRoutineNew(schoolId: string): string {
    return `/school/${schoolId}/routine/new`;
}

export function routeRoutineFeed(schoolId: string, classroomId: string, routineId: string, eventDate: string): string {
    return `/school/${schoolId}/classroom/${classroomId}/routine/${routineId}/feed/${eventDate}`;
}

// export function routeRoutineStudentAdd(schoolId: string, routineId: string): string {
//     return `/school/${schoolId}/routine/${routineId}/student/add`;
// }

// export function routeRoutineUserAdd(schoolId: string, routineId: string): string {
//     return `/school/${schoolId}/routine/${routineId}/user/new`;
// }

// export function routeRoutineImagesAdd(schoolId: string, routineId: string): string {
//     return `/school/${schoolId}/routine/${routineId}/images/add`;
// }